export const DMNNM = "radheexch";
export const DMN = "com";
export const OPRTR_ID = "RDE";
export const ReCAPTCHA__KEY = "6Ld-SrAaAAAAAKPTAvYPMP3bWU-_3En7_UK09iII";
export const CHKALLW = true;
